<div class="modal modal-show-qr">
  <img [src]="url" alt="QR Code">
  <button class="close-round" mat-dialog-close>
    <span class="close-round__btn"></span>
  </button>
</div>
